/*
 * @Author: shuchang
 * @Date: 2022-03-22 09:27:40
 * @LastEditors: shuchang
 * @LastEditTime: 2022-04-19 15:34:36
 * @Description: 
 */
import labelSet from './components/labelSet/main';
import leftMenu from './components/leftMenu/myMenu';

// import dialog from './components/dialog'
const YMUI = {
    labelSet,
    leftMenu
    // 这里是后续补充的组件
}
const install = function(Vue, opts = {}) {
    if (install.installed) return
    Object.keys(YMUI).forEach(key => {
        Vue.component(key, YMUI[key])
    })

    Vue.prototype.$labelSet = labelSet
    Vue.prototype.$leftMenu = leftMenu
        //   Vue.prototype.$dialog = dialog
}

// auto install
if (typeof window !== 'undefined' && window.Vue) {

    window.Vue.use(install)
        // install(window.Vue) // 通过use方式全部引入
}

// const API = {
//     install,
//     ...YMUI
// }

export default install // 通过插件单独引入